import React from "react";
import PropTypes from "prop-types";
import ListItem from "../ListItem";
import NoDataBanner from "../NoDataBanner";
import { StyledList } from "./_.styled";

const LinksList = ({ items, noDataText, onItemClick, ...props }) => {
  const renderItem = (item) => (
    <li key={item.id}>
      <ListItem
        label={item.displayLabel}
        href={item.href}
        onClick={onItemClick ? () => onItemClick(item) : null}
      />
      {item.subItems?.length > 0 && (
        <StyledList>{item.subItems.map(renderItem)}</StyledList>
      )}
    </li>
  );

  return (
    <div {...props}>
      {items.length ? (
        <StyledList data-testid="links-list">
          {items.map(renderItem)}
        </StyledList>
      ) : (
        <NoDataBanner label={noDataText} />
      )}
    </div>
  );
};

const itemPropTypes = {
  id: PropTypes.string.isRequired,
  href: PropTypes.string,
  displayLabel: PropTypes.string.isRequired,
};

LinksList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      ...itemPropTypes,
      subItems: PropTypes.arrayOf(PropTypes.shape(itemPropTypes)),
    })
  ).isRequired,
  noDataText: PropTypes.string,
  onItemClick: PropTypes.func,
};

export default LinksList;
